import { withCallAPI } from '01_core/components/system/CallAPI';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import withResponsive from '01_core/hooks/withResponsive';

import SafetyInfoField from './components/SafetyInfoField';
import GrouphisaiInfoField from './components/GrouphisaiInfoField';
import HomeGrid from './components/HomeGrid';
import NoticeInfoField from './components/NoticeInfoField';
import UserInfoField from './components/UserInfoField';
import { PERMISSION_KEY, TYPES, homeActions } from './homeActions';

class Home extends React.Component {
  constructor(props) {
    super(props);

    let menuDispList = this.createMenuDispList();
    this.setPermission(menuDispList);
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  createMenuDispList = () => {
    let menuDispList = {};

    const menuListLv3 = (menuData) => {
      menuData.forEach(({ fid, acd, pms }, i) => {
        menuDispList[fid] = { fid, acd, pms };
      });
    };

    const menuListLv2 = (menuData) => {
      menuData.forEach(({ fid, acd, childs, pms }, i) => {
        if (childs.length === 0) {
          menuDispList[fid] = { fid, acd, pms };
        }
        childs && menuListLv3(childs);
      });
    };

    const menuList = (menuData) => {
      menuData.forEach((menuItems, i) => {
        menuListLv2(menuItems.childs);
      });
    };

    menuList(this.props.menuData.filter((menu) => menu.fid.startsWith('menu')));

    return menuDispList;
  };

  setPermission = (menuData) => {
    const permission = {};
    Object.keys(PERMISSION_KEY).forEach((key) => {
      const val = PERMISSION_KEY[key];
      permission[val] = menuData[val] ? true : false;
    });

    this.props.setPermission(permission);
  };

  gridSizeMain = () => {
    const { width, mobile, menuState } = this.props;

    switch (width) {
      case 'xs':
        return 12;
      case 'sm':
        return 12;
      case 'md':
        return !mobile && menuState ? 12 : 'auto';
      default:
        return 'auto';
    }
  };

  gridSizeRight = () => {
    const { width, mobile, menuState } = this.props;

    switch (width) {
      case 'xs':
        return 12;
      case 'sm':
        return 12;
      case 'md':
        return !mobile && menuState ? 12 : 'fixed';
      default:
        return 'fixed';
    }
  };

  render = () => {
    const { permission, menuState, mobile, loginUserAuth } = this.props;

    return (
      <div>
        <HomeGrid container>
          <HomeGrid item gridSize={this.gridSizeMain()}>
            <HomeGrid container>
              <HomeGrid item gridSize={12}>
                <SafetyInfoField
                  menuState={menuState}
                  mobile={mobile}
                />
              </HomeGrid>
              {permission[PERMISSION_KEY.GROUPHISAI_SEARCH] ? (
                <HomeGrid item gridSize={12}>
                  <GrouphisaiInfoField
                    checkNewInfo={this.checkNewInfo}
                    menuState={menuState}
                    mobile={mobile}
                  />
                </HomeGrid>
              ) : null}
            </HomeGrid>
          </HomeGrid>

          <HomeGrid item gridSize={this.gridSizeRight()} fixedWidth={400}>
            <HomeGrid container>
              { loginUserAuth.authFlg === 0 ? (
                <HomeGrid item gridSize={12}>
                  <UserInfoField />
                </HomeGrid>
              ) : null }
              <HomeGrid item gridSize={12}>
                <NoticeInfoField />
              </HomeGrid>
            </HomeGrid>
          </HomeGrid>
        </HomeGrid>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    systemLink: state.coreLoginInfo.systemLink,
    menuData: state.coreLoginInfo.menuData,
    loginUserAuth: state.coreLoginInfo.loginUser.loginUserAuth,
    systemSettings: state.coreLoginInfo.systemSettings,
    permission: state.home.permission,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPermission: (key, flg) => dispatch(homeActions[TYPES.SET_PERMISSION](key, flg)),
    setHomeData: (fid, data) => dispatch(homeActions[TYPES.SET_HOME_DATA](fid, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withResponsive(injectIntl(withCallAPI(Home))));
